import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockType } from '../../../../../config/api/models/Block';
import { Icons } from '../../../../shared/components';
import AddBlockButtonLarge from './AddBlockButtonLarge';
import { AddBlockButtonProps } from '../../../types';
import AddBlockButton from './AddBlockButton';
import { AddContentDialog } from './AddContentDialog';

const AddVideoBlockButton: FC<AddBlockButtonProps> = ({
  bookId,
  pageId,
  viewMode,
  previousBlockId,
  clusterId, // TODO - use this!!
  sectionId,
}) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  return (
    <>
      {
        {
          emptyPage: (
            <AddBlockButtonLarge
              title={t(`trajectory.page.blocks.video.title`)}
              description={t(`trajectory.page.blocks.video.description`)}
              icon={Icons.BLOCK_TYPE_VIDEO}
              onClick={() => setDialogOpen(true)}
            />
          ),
          sidebar: <AddBlockButton type={BlockType.VIDEO} onClick={() => setDialogOpen(true)} />,
        }[viewMode]
      }
      <AddContentDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        pageId={pageId}
        bookId={bookId}
        clusterId={clusterId}
        sectionId={sectionId}
        previousBlockId={previousBlockId}
        validationType="isVideo"
      />
    </>
  );
};

export default AddVideoBlockButton;
